import { GateDecision } from './gateTypes';

type GateHandlerDeps = {
  navigate: (to: string) => void;
  toast?: (message: string) => void;
  returnUrl?: string;
};

export const handleGateDecision = (
  decision: GateDecision,
  { navigate, toast, returnUrl }: GateHandlerDeps
): boolean => {
  if (decision.allow) return true;

  if (decision.action === 'PAYWALL') {
    const target = decision.redirectTo || returnUrl || '/';
    navigate(`/subscribe?return=${encodeURIComponent(target)}`);
    return false;
  }

  if (decision.action === 'REDIRECT') {
    navigate(decision.redirectTo || '/');
    return false;
  }

  if (decision.action === 'TOAST') {
    if (toast) toast(decision.reason);
    return false;
  }

  return false;
};
